export { PostCard } from './post-card';
export type { PostCardProps } from './post-card';
